import React, {useEffect, useState} from "react";
import Layout from "@/layout/Layout";
import MButton from "@/components/atom/MButton";
import {useHistory} from "react-router";
import style from './HomePage.scss'
import _ from "lodash";
import HomePagePanel from "@/components/homePage/HomePagePanel";
import {deletePhoto, getPhotos} from "@/api/photo";
import globalStyle from "@/styles/Global.scss";

const EditHomePage = () => {
  const history = useHistory()
  const [photos, setPhotos] = useState([])

  useEffect(() => {
    (async () => {
      await loadPhotos()
    })()
  }, [])

  const loadPhotos = async () => {
    const photos = await getPhotos()
    setPhotos(photos)
  }

  const toEditHomePagePanel = ({photo}) => {
    history.push(`/homePage/edit/${photo.id}`)
  }
  const toAddHomePagePanel = () => {
    history.push(`/homePage/add`)
  }

  const goBack = () => {
    history.push(`/homePage`)
  }

  const onDeletePhoto = async ({photo}) => {
    const isOk = window.confirm(`「${photo.title}」を削除します。よろしいですか？`)
    if (!isOk) {
      return
    }
    await deletePhoto({id: photo.id})
    await loadPhotos()
  }

  return (
    <>
      <Layout title={'ホームページ'}>
        <div className={style.editButtonPanel}>
          ホームページのコンテンツを作成します。
        </div>
        <div>
          {
            _.map(photos, (photo) => {
              return (
                <React.Fragment key={photo.id}>
                  <div className={style.editButtonPanel}>
                    <MButton image={'tsuika.png'} value={'追加'} onClick={toAddHomePagePanel}></MButton>
                    <MButton image={'edit.png'} value={'編集'} onClick={() => toEditHomePagePanel({photo})}></MButton>
                    <MButton image={'sakujo.png'} value={'削除'} onClick={() => onDeletePhoto({photo})}></MButton>
                    <MButton image={'back.png'} value={'戻る'} onClick={goBack}></MButton>
                  </div>
                  <HomePagePanel photo={photo}></HomePagePanel>
                  <hr className={globalStyle.separator} />
                </React.Fragment>
              )
            })
          }
        </div>
        <div className={style.editButtonPanel}>
          <MButton image={'tsuika.png'} value={'追加'} onClick={toAddHomePagePanel}></MButton>
          <MButton image={'back.png'} value={'戻る'} onClick={goBack}></MButton>
        </div>
      </Layout>
    </>
  )
}

export default EditHomePage
